import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, FormLabel, FormError, Input as FormInput } from './styled'

const Input = ({
  field,
  form: { touched, errors },
  label,
  placeholder,
  margin,
  ...props
}) => (
  <FormGroup hasValue={!!field.value} margin={margin}>
    {!!label && <FormLabel>{label}</FormLabel>}
    <FormInput {...field} {...props} placeholder={placeholder} />

    {touched[field.name] && errors[field.name] && (
      <FormError>{errors[field.name]}</FormError>
    )}
  </FormGroup>
)

Input.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  margin: PropTypes.string,
}

Input.defaultProps = {
  placeholder: undefined,
  label: undefined,
  margin: undefined,
}

export default Input
